import { actions as F } from "./store/reducer.js";
var k = function(n) {
  return "@@redux-saga/" + n;
}, un = /* @__PURE__ */ k("CANCEL_PROMISE"), cn = /* @__PURE__ */ k("CHANNEL_END"), fn = /* @__PURE__ */ k("IO"), tn = /* @__PURE__ */ k("MATCH"), sn = /* @__PURE__ */ k("MULTICAST"), ln = /* @__PURE__ */ k("SAGA_ACTION"), vn = /* @__PURE__ */ k("SELF_CANCELLATION"), _n = /* @__PURE__ */ k("TASK"), j = /* @__PURE__ */ k("TASK_CANCEL"), dn = /* @__PURE__ */ k("TERMINATE"), Jn = /* @__PURE__ */ k("LOCATION");
function H() {
  return H = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, H.apply(null, arguments);
}
function ne(e, n) {
  if (e == null) return {};
  var t = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (n.indexOf(r) !== -1) continue;
    t[r] = e[r];
  }
  return t;
}
var hn = function(n) {
  return n == null;
}, D = function(n) {
  return n != null;
}, C = function(n) {
  return typeof n == "function";
}, V = function(n) {
  return typeof n == "string";
}, L = Array.isArray, W = function(n) {
  return n && C(n.then);
}, Q = function(n) {
  return n && C(n.next) && C(n.throw);
}, z = function(n) {
  return n && (V(n) || En(n) || C(n) || L(n) && n.every(z));
}, gn = function(n) {
  return n && C(n.take) && C(n.close);
}, ee = function(n) {
  return C(n) && n.hasOwnProperty("toString");
}, En = function(n) {
  return !!n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype;
}, te = function(n) {
  return gn(n) && n[sn];
}, re = 2147483647;
function ae(e, n) {
  n === void 0 && (n = !0);
  var t, r = new Promise(function(u) {
    t = setTimeout(u, Math.min(re, e), n);
  });
  return r[un] = function() {
    clearTimeout(t);
  }, r;
}
var oe = function(n) {
  return function() {
    return n;
  };
}, pn = /* @__PURE__ */ oe(!0), y = function() {
}, mn = function(n) {
  return n;
}, Y = function(n, t) {
  H(n, t), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(function(r) {
    n[r] = t[r];
  });
}, ue = function(n, t) {
  var r;
  return (r = []).concat.apply(r, t.map(n));
};
function G(e, n) {
  var t = e.indexOf(n);
  t >= 0 && e.splice(t, 1);
}
function yn(e) {
  var n = !1;
  return function() {
    n || (n = !0, e());
  };
}
var ce = function(n) {
  throw n;
}, ie = function(n) {
  return {
    value: n,
    done: !0
  };
};
function rn(e, n, t) {
  n === void 0 && (n = ce), t === void 0 && (t = "iterator");
  var r = {
    meta: {
      name: t
    },
    next: e,
    throw: n,
    return: ie,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (r[Symbol.iterator] = function() {
    return r;
  }), r;
}
function fe(e, n) {
  var t = n.sagaStack;
  console.error(e), console.error(t);
}
var Cn = function(n) {
  return Array.apply(null, new Array(n));
}, se = function(n) {
  return function(t) {
    return n(Object.defineProperty(t, ln, {
      value: !0
    }));
  };
}, An = function(n) {
  return n === dn;
}, Sn = function(n) {
  return n === j;
}, Tn = function(n) {
  return An(n) || Sn(n);
};
function Nn(e, n) {
  var t = Object.keys(e), r = t.length, u = 0, c, i = L(e) ? Cn(r) : {}, o = {};
  function a() {
    u === r && (c = !0, n(i));
  }
  return t.forEach(function(s) {
    var f = function(h, p) {
      c || (p || Tn(h) ? (n.cancel(), n(h, p)) : (i[s] = h, u++, a()));
    };
    f.cancel = y, o[s] = f;
  }), n.cancel = function() {
    c || (c = !0, t.forEach(function(s) {
      return o[s].cancel();
    }));
  }, o;
}
function Z(e) {
  return {
    name: e.name || "anonymous",
    location: kn(e)
  };
}
function kn(e) {
  return e[Jn];
}
function le() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return n.length === 0 ? function(r) {
    return r;
  } : n.length === 1 ? n[0] : n.reduce(function(r, u) {
    return function() {
      return r(u.apply(void 0, arguments));
    };
  });
}
var ve = "Channel's Buffer overflow!", de = 1, he = 3, xn = 4, ge = {
  isEmpty: pn,
  put: y,
  take: y
};
function Ee(e, n) {
  e === void 0 && (e = 10);
  var t = new Array(e), r = 0, u = 0, c = 0, i = function(f) {
    t[u] = f, u = (u + 1) % e, r++;
  }, o = function() {
    if (r != 0) {
      var f = t[c];
      return t[c] = null, r--, c = (c + 1) % e, f;
    }
  }, a = function() {
    for (var f = []; r; )
      f.push(o());
    return f;
  };
  return {
    isEmpty: function() {
      return r == 0;
    },
    put: function(f) {
      if (r < e)
        i(f);
      else {
        var l;
        switch (n) {
          case de:
            throw new Error(ve);
          case he:
            t[u] = f, u = (u + 1) % e, c = u;
            break;
          case xn:
            l = 2 * e, t = a(), r = t.length, u = t.length, c = 0, t.length = l, e = l, i(f);
            break;
        }
      }
    },
    take: o,
    flush: a
  };
}
var pe = function() {
  return ge;
}, me = function(n) {
  return Ee(n, xn);
}, K = "TAKE", wn = "PUT", Ln = "ALL", ye = "RACE", Rn = "CALL", Ce = "CPS", In = "FORK", Ae = "JOIN", Mn = "CANCEL", On = "SELECT", Se = "ACTION_CHANNEL", Te = "CANCELLED", Ne = "FLUSH", ke = "GET_CONTEXT", xe = "SET_CONTEXT", w = function(n, t) {
  var r;
  return r = {}, r[fn] = !0, r.combinator = !1, r.type = n, r.payload = t, r;
};
function we(e, n) {
  if (e === void 0 && (e = "*"), z(e))
    return D(n) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), w(K, {
      pattern: e
    });
  if (te(e) && D(n) && z(n))
    return w(K, {
      channel: e,
      pattern: n
    });
  if (gn(e))
    return D(n) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), w(K, {
      channel: e
    });
}
function jn(e, n) {
  return hn(n) && (n = e, e = void 0), w(wn, {
    channel: e,
    action: n
  });
}
function st(e) {
  var n = w(Ln, e);
  return n.combinator = !0, n;
}
function bn(e, n) {
  var t = null, r;
  return C(e) ? r = e : (L(e) ? (t = e[0], r = e[1]) : (t = e.context, r = e.fn), t && V(r) && C(t[r]) && (r = t[r])), {
    context: t,
    fn: r,
    args: n
  };
}
function Fn(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    t[r - 1] = arguments[r];
  return w(Rn, bn(e, t));
}
function lt(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    t[r - 1] = arguments[r];
  return w(In, bn(e, t));
}
function vt(e) {
  return e === void 0 && (e = vn), w(Mn, e);
}
function dt(e) {
  e === void 0 && (e = mn);
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    t[r - 1] = arguments[r];
  return w(On, {
    selector: e,
    args: t
  });
}
var Le = /* @__PURE__ */ Fn.bind(null, ae);
function Re() {
  var e = {};
  return e.promise = new Promise(function(n, t) {
    e.resolve = n, e.reject = t;
  }), e;
}
var Pn = [], $ = 0;
function Ie(e) {
  try {
    _(), e();
  } finally {
    Un();
  }
}
function Dn(e) {
  Pn.push(e), $ || (_(), Hn());
}
function Kn(e) {
  try {
    return _(), e();
  } finally {
    Hn();
  }
}
function _() {
  $++;
}
function Un() {
  $--;
}
function Hn() {
  Un();
  for (var e; !$ && (e = Pn.shift()) !== void 0; )
    Ie(e);
}
var Me = function(n) {
  return function(t) {
    return n.some(function(r) {
      return J(r)(t);
    });
  };
}, Oe = function(n) {
  return function(t) {
    return n(t);
  };
}, an = function(n) {
  return function(t) {
    return t.type === String(n);
  };
}, je = function(n) {
  return function(t) {
    return t.type === n;
  };
}, Wn = function() {
  return pn;
};
function J(e) {
  var n = e === "*" ? Wn : V(e) ? an : L(e) ? Me : ee(e) ? an : C(e) ? Oe : En(e) ? je : null;
  if (n === null)
    throw new Error("invalid pattern: " + e);
  return n(e);
}
var O = {
  type: cn
}, B = function(n) {
  return n && n.type === cn;
};
function Gn(e) {
  e === void 0 && (e = me());
  var n = !1, t = [];
  function r(o) {
    if (!n) {
      if (t.length === 0)
        return e.put(o);
      var a = t.shift();
      a(o);
    }
  }
  function u(o) {
    n && e.isEmpty() ? o(O) : e.isEmpty() ? (t.push(o), o.cancel = function() {
      G(t, o);
    }) : o(e.take());
  }
  function c(o) {
    if (n && e.isEmpty()) {
      o(O);
      return;
    }
    o(e.flush());
  }
  function i() {
    if (!n) {
      n = !0;
      var o = t;
      t = [];
      for (var a = 0, s = o.length; a < s; a++) {
        var f = o[a];
        f(O);
      }
    }
  }
  return {
    take: u,
    put: r,
    flush: c,
    close: i
  };
}
function $n(e, n) {
  n === void 0 && (n = pe());
  var t = !1, r, u = Gn(n), c = function() {
    t || (t = !0, C(r) && r(), u.close());
  };
  return r = e(function(i) {
    if (B(i)) {
      c();
      return;
    }
    u.put(i);
  }), r = yn(r), t && r(), {
    take: u.take,
    flush: u.flush,
    close: c
  };
}
function be() {
  var e, n = !1, t = [], r = t, u = function() {
    r === t && (r = t.slice());
  }, c = function() {
    n = !0;
    var o = t = r;
    r = [], o.forEach(function(a) {
      a(O);
    });
  };
  return e = {}, e[sn] = !0, e.put = function(o) {
    if (!n) {
      if (B(o)) {
        c();
        return;
      }
      for (var a = t = r, s = 0, f = a.length; s < f; s++) {
        var l = a[s];
        l[tn](o) && (l.cancel(), l(o));
      }
    }
  }, e.take = function(o, a) {
    if (a === void 0 && (a = Wn), n) {
      o(O);
      return;
    }
    o[tn] = a, u(), r.push(o), o.cancel = yn(function() {
      u(), G(r, o);
    });
  }, e.close = c, e;
}
function Bn() {
  var e = be(), n = e.put;
  return e.put = function(t) {
    if (t[ln]) {
      n(t);
      return;
    }
    Dn(function() {
      n(t);
    });
  }, e;
}
var M = 0, x = 1, U = 2, Xn = 3;
function nn(e, n) {
  var t = e[un];
  C(t) && (n.cancel = t), e.then(n, function(r) {
    n(r, !0);
  });
}
var P = 0, qn = (function() {
  return ++P;
}), m;
function Fe(e, n) {
  return e.isSagaIterator ? {
    name: e.meta.name
  } : Z(n);
}
function Pe(e) {
  var n = e.context, t = e.fn, r = e.args;
  try {
    var u = t.apply(n, r);
    if (Q(u))
      return u;
    var c = !1, i = function(a) {
      return c ? {
        value: a,
        done: !0
      } : (c = !0, {
        value: u,
        done: !W(u)
      });
    };
    return rn(i);
  } catch (o) {
    return rn(function() {
      throw o;
    });
  }
}
function De(e, n, t) {
  var r = n.channel, u = n.action, c = n.resolve;
  Dn(function() {
    var i;
    try {
      i = (r ? r.put : e.dispatch)(u);
    } catch (o) {
      t(o, !0);
      return;
    }
    c && W(i) ? nn(i, t) : t(i);
  });
}
function Ke(e, n, t) {
  var r = n.channel, u = r === void 0 ? e.channel : r, c = n.pattern, i = n.maybe, o = function(s) {
    if (s instanceof Error) {
      t(s, !0);
      return;
    }
    if (B(s) && !i) {
      t(dn);
      return;
    }
    t(s);
  };
  try {
    u.take(o, D(c) ? J(c) : null);
  } catch (a) {
    t(a, !0);
    return;
  }
  t.cancel = o.cancel;
}
function Ue(e, n, t, r) {
  var u = n.context, c = n.fn, i = n.args, o = r.task;
  try {
    var a = c.apply(u, i);
    if (W(a)) {
      nn(a, t);
      return;
    }
    if (Q(a)) {
      X(
        e,
        a,
        o.context,
        P,
        Z(c),
        /* isRoot */
        !1,
        t
      );
      return;
    }
    t(a);
  } catch (s) {
    t(s, !0);
  }
}
function He(e, n, t) {
  var r = n.context, u = n.fn, c = n.args;
  try {
    var i = function(a, s) {
      hn(a) ? t(s) : t(a, !0);
    };
    u.apply(r, c.concat(i)), i.cancel && (t.cancel = i.cancel);
  } catch (o) {
    t(o, !0);
  }
}
function We(e, n, t, r) {
  var u = n.context, c = n.fn, i = n.args, o = n.detached, a = r.task, s = Pe({
    context: u,
    fn: c,
    args: i
  }), f = Fe(s, c);
  Kn(function() {
    var l = X(e, s, a.context, P, f, o, void 0);
    o ? t(l) : l.isRunning() ? (a.queue.addTask(l), t(l)) : l.isAborted() ? a.queue.abort(l.error()) : t(l);
  });
}
function Ge(e, n, t, r) {
  var u = r.task, c = function(a, s) {
    if (a.isRunning()) {
      var f = {
        task: u,
        cb: s
      };
      s.cancel = function() {
        a.isRunning() && G(a.joiners, f);
      }, a.joiners.push(f);
    } else
      a.isAborted() ? s(a.error(), !0) : s(a.result());
  };
  if (L(n)) {
    if (n.length === 0) {
      t([]);
      return;
    }
    var i = Nn(n, t);
    n.forEach(function(o, a) {
      c(o, i[a]);
    });
  } else
    c(n, t);
}
function q(e) {
  e.isRunning() && e.cancel();
}
function $e(e, n, t, r) {
  var u = r.task;
  n === vn ? q(u) : L(n) ? n.forEach(q) : q(n), t();
}
function Be(e, n, t, r) {
  var u = r.digestEffect, c = P, i = Object.keys(n);
  if (i.length === 0) {
    t(L(n) ? [] : {});
    return;
  }
  var o = Nn(n, t);
  i.forEach(function(a) {
    u(n[a], c, o[a], a);
  });
}
function Xe(e, n, t, r) {
  var u = r.digestEffect, c = P, i = Object.keys(n), o = L(n) ? Cn(i.length) : {}, a = {}, s = !1;
  i.forEach(function(f) {
    var l = function(p, E) {
      s || (E || Tn(p) ? (t.cancel(), t(p, E)) : (t.cancel(), s = !0, o[f] = p, t(o)));
    };
    l.cancel = y, a[f] = l;
  }), t.cancel = function() {
    s || (s = !0, i.forEach(function(f) {
      return a[f].cancel();
    }));
  }, i.forEach(function(f) {
    s || u(n[f], c, a[f], f);
  });
}
function qe(e, n, t) {
  var r = n.selector, u = n.args;
  try {
    var c = r.apply(void 0, [e.getState()].concat(u));
    t(c);
  } catch (i) {
    t(i, !0);
  }
}
function ze(e, n, t) {
  var r = n.pattern, u = n.buffer, c = Gn(u), i = J(r), o = function(f) {
    B(f) || e.channel.take(o, i), c.put(f);
  }, a = c.close;
  c.close = function() {
    o.cancel(), a();
  }, e.channel.take(o, i), t(c);
}
function Ve(e, n, t, r) {
  var u = r.task;
  t(u.isCancelled());
}
function Qe(e, n, t) {
  n.flush(t);
}
function Ye(e, n, t, r) {
  var u = r.task;
  t(u.context[n]);
}
function Ze(e, n, t, r) {
  var u = r.task;
  Y(u.context, n), t();
}
var _e = (m = {}, m[K] = Ke, m[wn] = De, m[Ln] = Be, m[ye] = Xe, m[Rn] = Ue, m[Ce] = He, m[In] = We, m[Ae] = Ge, m[Mn] = $e, m[On] = qe, m[Se] = ze, m[Te] = Ve, m[Ne] = Qe, m[ke] = Ye, m[xe] = Ze, m);
function Je(e, n, t) {
  var r = [], u, c = !1;
  a(e);
  var i = function() {
    return r;
  };
  function o(f) {
    n(), s(), t(f, !0);
  }
  function a(f) {
    r.push(f), f.cont = function(l, h) {
      c || (G(r, f), f.cont = y, h ? o(l) : (f === e && (u = l), r.length || (c = !0, t(u))));
    };
  }
  function s() {
    c || (c = !0, r.forEach(function(f) {
      f.cont = y, f.cancel();
    }), r = []);
  }
  return {
    addTask: a,
    cancelAll: s,
    abort: o,
    getTasks: i
  };
}
function zn(e, n) {
  return e + "?" + n;
}
function nt(e) {
  var n = kn(e);
  if (n) {
    var t = n.code, r = n.fileName, u = n.lineNumber, c = t + "  " + zn(r, u);
    return c;
  }
  return "";
}
function on(e) {
  var n = e.name, t = e.location;
  return t ? n + "  " + zn(t.fileName, t.lineNumber) : n;
}
function et(e) {
  var n = ue(function(t) {
    return t.cancelledTasks;
  }, e);
  return n.length ? ["Tasks cancelled due to error:"].concat(n).join(`
`) : "";
}
var en = null, b = [], tt = function(n) {
  n.crashedEffect = en, b.push(n);
}, Vn = function() {
  en = null, b.length = 0;
}, rt = function(n) {
  en = n;
}, at = function() {
  var n = b[0], t = b.slice(1), r = n.crashedEffect ? nt(n.crashedEffect) : null, u = "The above error occurred in task " + on(n.meta) + (r ? ` 
 when executing effect ` + r : "");
  return [u].concat(t.map(function(c) {
    return "    created by " + on(c.meta);
  }), [et(b)]).join(`
`);
};
function ot(e, n, t, r, u, c, i) {
  var o;
  i === void 0 && (i = y);
  var a = M, s, f, l = null, h = [], p = Object.create(t), E = Je(n, function() {
    h.push.apply(h, E.getTasks().map(function(N) {
      return N.meta.name;
    }));
  }, A);
  function d() {
    a === M && (a = x, E.cancelAll(), A(j, !1));
  }
  function A(v, N) {
    if (!N)
      v === j ? a = x : a !== x && (a = Xn), s = v, l && l.resolve(v);
    else {
      if (a = U, tt({
        meta: u,
        cancelledTasks: h
      }), S.isRoot) {
        var R = at();
        Vn(), e.onError(v, {
          sagaStack: R
        });
      }
      f = v, l && l.reject(v);
    }
    S.cont(v, N), S.joiners.forEach(function(I) {
      I.cb(v, N);
    }), S.joiners = null;
  }
  function g(v) {
    Y(p, v);
  }
  function T() {
    return l || (l = Re(), a === U ? l.reject(f) : a !== M && l.resolve(s)), l.promise;
  }
  var S = (o = {}, o[_n] = !0, o.id = r, o.meta = u, o.isRoot = c, o.context = p, o.joiners = [], o.queue = E, o.cancel = d, o.cont = i, o.end = A, o.setContext = g, o.toPromise = T, o.isRunning = function() {
    return a === M;
  }, o.isCancelled = function() {
    return a === x || a === M && n.status === x;
  }, o.isAborted = function() {
    return a === U;
  }, o.result = function() {
    return s;
  }, o.error = function() {
    return f;
  }, o);
  return S;
}
function X(e, n, t, r, u, c, i) {
  var o = e.finalizeRunEffect(p);
  h.cancel = y;
  var a = {
    meta: u,
    cancel: l,
    status: M
  }, s = ot(e, a, t, r, u, c, i), f = {
    task: s,
    digestEffect: E
  };
  function l() {
    a.status === M && (a.status = x, h(j));
  }
  return i && (i.cancel = s.cancel), h(), s;
  function h(d, A) {
    try {
      var g;
      A ? (g = n.throw(d), Vn()) : Sn(d) ? (a.status = x, h.cancel(), g = C(n.return) ? n.return(j) : {
        done: !0,
        value: j
      }) : An(d) ? g = C(n.return) ? n.return() : {
        done: !0
      } : g = n.next(d), g.done ? (a.status !== x && (a.status = Xn), a.cont(g.value)) : E(g.value, r, h);
    } catch (T) {
      if (a.status === x)
        throw T;
      a.status = U, a.cont(T, !0);
    }
  }
  function p(d, A, g) {
    if (W(d))
      nn(d, g);
    else if (Q(d))
      X(
        e,
        d,
        s.context,
        A,
        u,
        /* isRoot */
        !1,
        g
      );
    else if (d && d[fn]) {
      var T = _e[d.type];
      T(e, d.payload, g, f);
    } else
      g(d);
  }
  function E(d, A, g, T) {
    T === void 0 && (T = "");
    var S = qn();
    e.sagaMonitor && e.sagaMonitor.effectTriggered({
      effectId: S,
      parentEffectId: A,
      label: T,
      effect: d
    });
    var v;
    function N(R, I) {
      v || (v = !0, g.cancel = y, e.sagaMonitor && (I ? e.sagaMonitor.effectRejected(S, R) : e.sagaMonitor.effectResolved(S, R)), I && rt(d), g(R, I));
    }
    N.cancel = y, g.cancel = function() {
      v || (v = !0, N.cancel(), N.cancel = y, e.sagaMonitor && e.sagaMonitor.effectCancelled(S));
    }, o(d, S, N);
  }
}
function ut(e, n) {
  for (var t = e.channel, r = t === void 0 ? Bn() : t, u = e.dispatch, c = e.getState, i = e.context, o = i === void 0 ? {} : i, a = e.sagaMonitor, s = e.effectMiddlewares, f = e.onError, l = f === void 0 ? fe : f, h = arguments.length, p = new Array(h > 2 ? h - 2 : 0), E = 2; E < h; E++)
    p[E - 2] = arguments[E];
  var d = n.apply(void 0, p), A = qn();
  a && (a.rootSagaStarted = a.rootSagaStarted || y, a.effectTriggered = a.effectTriggered || y, a.effectResolved = a.effectResolved || y, a.effectRejected = a.effectRejected || y, a.effectCancelled = a.effectCancelled || y, a.actionDispatched = a.actionDispatched || y, a.rootSagaStarted({
    effectId: A,
    saga: n,
    args: p
  }));
  var g;
  if (s) {
    var T = le.apply(void 0, s);
    g = function(N) {
      return function(R, I, Qn) {
        var Yn = function(Zn) {
          return N(Zn, I, Qn);
        };
        return T(Yn)(R);
      };
    };
  } else
    g = mn;
  var S = {
    channel: r,
    dispatch: se(u),
    getState: c,
    sagaMonitor: a,
    onError: l,
    finalizeRunEffect: g
  };
  return Kn(function() {
    var v = X(
      S,
      d,
      o,
      A,
      Z(n),
      /* isRoot */
      !0,
      void 0
    );
    return a && a.effectResolved(A, v), v;
  });
}
var ct = ["context", "channel", "sagaMonitor"];
function ht(e) {
  var n = {}, t = n.context, r = t === void 0 ? {} : t, u = n.channel, c = u === void 0 ? Bn() : u, i = n.sagaMonitor, o = ne(n, ct), a;
  function s(f) {
    var l = f.getState, h = f.dispatch;
    return a = ut.bind(null, H({}, o, {
      context: r,
      channel: c,
      dispatch: h,
      getState: l,
      sagaMonitor: i
    })), function(p) {
      return function(E) {
        i && i.actionDispatched && i.actionDispatched(E);
        var d = p(E);
        return c.put(E), d;
      };
    };
  }
  return s.run = function() {
    return a.apply(void 0, arguments);
  }, s.setContext = function(f) {
    Y(r, f);
  }, s;
}
const gt = 6e3;
function Et(e) {
  return $n((n) => {
    const t = () => (n(F.connectionLost()), n(O));
    return e.onmessage = (r) => {
      if (r.data !== "Not Found")
        return n(F.storeReceivedMessage(JSON.parse(r.data)));
    }, e.onclose = t, e.onerror = t, () => {
      e.close();
    };
  });
}
function* pt(e) {
  for (; ; ) {
    const { payload: n } = yield we(F.send);
    yield jn(F.storeSentMessage(n)), yield Fn([e, e.send], JSON.stringify(n));
  }
}
function* mt(e) {
  try {
    for (; ; )
      yield Le(1e3 * 60 * 9.5), yield jn(
        F.send({
          action: "keepAlive"
        })
      );
  } catch {
    console.log("failed to keep alive websocket conection");
  }
}
function yt(e, n) {
  return $n((t) => {
    const r = () => t(O), u = e.subscribe((c) => t(n(c)));
    return () => {
      u.unsubscribe(), r();
    };
  });
}
export {
  gt as R,
  ee as a,
  C as b,
  gn as c,
  Fn as d,
  vt as e,
  lt as f,
  st as g,
  pt as h,
  Le as i,
  mt as j,
  dt as k,
  yt as l,
  rn as m,
  jn as p,
  ht as s,
  we as t,
  Et as w
};
